export default [
  {
    path: '/fo/sample',
    name: '샘플',
    component: () => import('@/page/Sample.vue'),
  },
  {
    path: '/fo/sample/page',
    name: '샘플 페이지',
    component: () => import('@/page/SamplePage.vue'),
  },
  {
    path: '/fo/sample/solution/:folder/:file',
    name: '솔루션 샘플 페이지',
    component: () => import('@/page/SampleSolution'),
  },
  {
    path: '/fo/blank',
    name: 'blank',
    component: () => import('@/page/Blank.vue'),
  },
  {
    path: '/',
    name: '메인',
    component: () => import('@/page/main/Main.vue'),
    meta: {
      isHideHeader: true,
    }
  },
  // 챌린지
  {
    path: '/fo/mission',
    name: 'MissionMainIndex',
    component: () => import('@/page/mission/MissionMain.vue'),
    children: [
      {
        path: 'tutorial',
        name: 'MissionTutorialIndex',
        component: () => import('@/components/mission/MissionTutorial.vue')
      }
    ]
  },
  // {
  //   path: '/fo/chatting',
  //   name: '찐한대화',
  //   component: () => import('@/page/chatting/ChattingMain.vue'),
  //   meta: {
  //     // isHideHeader: false,
  //     // isMainBack: true,
  //     // isHideBack: true,
  //     headerTitle: '찐한 대화',
  //   }
  // },
  // {
  //   path: '/fo/chatting/list',
  //   name: '찐한 대화창 목록',
  //   component: () => import('@/page/chatting/ChattingList.vue'),
  //   meta: {
  //     isHideHeader: false,
  //     isHideBack: false,
  //     headerTitle: '찐한 대화창 목록',
  //   }
  // },
  // {
  //   path: '/fo/chatting/schedule',
  //   name: '찐한 대화 일정',
  //   component: () => import('@/page/chatting/ChattingSchedule.vue'),
  //   meta: {
  //     isHideHeader: false,
  //     isHideBack: false,
  //     headerTitle: '찐한 대화 일정',
  //   }
  // },
  // {
  //   path: '/fo/chatting/scheduleSelect',
  //   name: '찐한 일정 선택',
  //   component: () => import('@/page/chatting/ChattingScheduleSelect.vue'),
  //   meta: {
  //     isHideHeader: false,
  //     isHideBack: false,
  //     headerTitle: '',
  //   },
  //   props: true
  // },
  // {
  //   path: '/fo/chatting/lastDetail',
  //   name: '지난 찐한 대화',
  //   component: () => import('@/page/chatting/ChattingLastDetail.vue'),
  //   meta: {
  //     isHideHeader: false,
  //     isHideBack: false,
  //     headerTitle: '찐한 대화',
  //   },
  //   props: true
  // },
  {
    path: '/fo/intro',
    name: '여행 시작',
    component: () => import('@/page/main/Intro.vue'),
    meta: {
      isHideHeader: true,
    }
  },
  {
    path: '/fo/square',
    name: '광장',
    component: () => import('@/page/square/SquareMain.vue'),
    meta: {
      isHideHeader: true,
    }
  },
  {
    path: '/fo/suitcase',
    name: '여행가방',
    component: () => import('@/page/suitcase/SuitcaseMain.vue'),
    meta: {
      isHideHeader: true,
    }
  },
  {
    path: '/fo/notic',
    name: '알림',
    component: () => import('@/page/notification/Notification.vue'),
    meta: {
      headerTitle: '알림',
    },
  },
  {
    path: '/fo/travelMap',
    name: '여행지도',
    component: () => import('@/page/travelMap/TravelMap.vue'),
    meta: {
      // isHideHeader: false,
      headerTitle: '여행지도',
      // isHideBack: true,
      // isMainBack: true,
    }
  },
  {
    path: '/fo/guideSelect',
    name: '가이드 선택',
    component: () => import('@/page/guide/GuideSelect.vue'),
    meta: {
      isHideHeader: true,
    },
    props: true
  },
  {
    path: '/fo/guide',
    name: '가이드 평가',
    component: () => import('@/page/guide/GuideEvaluation.vue'),
  },
  {
    path: '/fo/survey',
    name: '설문조사',
    component: () => import('@/page/travelApplication/SurveyContainer.vue'),
  },
  {
    path: '/fo/squareMain',
    name: '광장메인',
    component: () => import('@/page/square/SquarePostList.vue'),
  },
  {
    path: '/fo/squarePostCmnt',
    name: '광장댓글',
    component: () => import('@/page/square/SquareCmntList.vue'),
  },

  {
    path: '/travelApplication/intro',
    name: 'travelIntro',
    component: () => import('@/page/travelApplication/SurveyContainer.vue'),
    meta: {
      headerTitle: '여행지원서',
      // isHideHeader: false,
    }
  },
  {
    path: '/fo/myTicket',
    name: '내 티켓',
    component: () => import('@/page/ticket/MyTicket.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '내 티켓',
    }
  },
  {
    path: '/fo/ticketSelect',
    name: '티켓 선택',
    component: () => import('@/page/ticket/TicketSelect.vue'),
    meta: {
      // isHideHeader: false,
      // headerTitle: '',
      // isMainBack: false,
      // isHideBack: true,
    }
  },
  {
    path: '/fo/TicketSelectEzn',
    name: '티켓 선택 EZN',
    component: () => import('@/page/ticket/TicketSelectEzn.vue'),
    meta: {
      // isHideHeader: false,
      // headerTitle: '',
      // isMainBack: false,
      // isHideBack: true,
    }
  },
  {
    path: '/fo/ticketRegister',
    name: '티켓 등록',
    component: () => import('@/page/ticket/TicketRegister.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '티켓 등록',
    }
  },
  {
    path: '/fo/ticketInfo',
    name: '상품 소개',
    component: () => import('@/page/ticket/TicketInfoEzn.vue'),
    meta: {
      isHideHeader: true
    }
  },
  {
    path: '/fo/ticketInfo/samsungfire',
    name: '상품 소개 삼성화재',
    component: () => import('@/page/ticket/TicketInfo.vue'),
    meta: {
      isHideHeader: true
    }
  },
  {
    path: '/fo/myInfo',
    name: '내 정보 관리',
    component: () => import('@/page/myInfo/MyInfo.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '내 정보 관리',
    }
  },
  {
    path: '/fo/nickname',
    name: '닉네임 관리',
    component: () => import('@/page/myInfo/Nickname.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '내정보 변경',
    }
  },
  {
    path: '/fo/myBadge',
    name: '내 뱃지',
    component: () => import('@/page/myInfo/MyBadge.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '내 뱃지',
    }
  },
  {
    path: '/fo/suitcase/TIC',
    name: '여행 안내소',
    component: () => import('@/page/suitcase/TouristInformationCenter.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '여행 안내소',
    }
  },
  {
    path: '/fo/suitcase/TIC/tutorial',
    name: '튜토리얼',
    component: () => import('@/page/suitcase/TIC/Tutorial.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '튜토리얼',
    }
  },
  {
    path: '/fo/suitcase/TIC/notificationSettings',
    name: '알림설정',
    component: () => import('@/page/suitcase/TIC/NotificationSettings.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '알림설정',
    }
  },
  {
    path: '/fo/suitcase/TIC/notic',
    name: '공지사항',
    component: () => import('@/page/suitcase/TIC/Notic.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '공지사항',
    }
  },
  {
    path: '/fo/suitcase/TIC/FAQ',
    name: '자주묻는 질문',
    component: () => import('@/page/suitcase/TIC/FAQ.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '자주묻는 질문',
    }
  },
  {
    path: '/fo/suitcase/TIC/kakao',
    name: '1:1문의',
    // afterEnter() {
    //   window.open('https://bizmessage.kakao.com/chat/open/@이지앤웰니스')
    // },
    meta: {
      isHideHeader: false,
      headerTitle: '1:1 고객문의',
    }
  },
  {
    path: '/fo/suitcase/mindWeather',
    name: '마음날씨',
    component: () => import('@/page/suitcase/MindWeather.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '마음날씨',
    }
  },
  {
    path: '/fo/suitcase/mindNote',
    name: '마음노트',
    component: () => import('@/page/suitcase/MindNote.vue'),
    meta: {
      isHideHeader: false,
      headerTitle: '마음노트',
    }
  },
  {
    path: '/fo/onboarding',
    name: '온보딩',
    component: () => import('@/page/onBoarding/Onboarding.vue'),
    meta: {
      isHideHeader: true,
    }
  },
  {
    path: '/fo/travelComplete',
    name: '여행완료',
    component: () => import('@/page/travelMap/TravelComplete.vue'),
    meta: {
      isHideHeader: true,
    }
  },
  {
    path: '/fo/survey/satisfaction',
    name: '만족도조사',
    component: () => import(`@/page/survey/SurveyMain.vue`),
    meta: {
      isHideHeader: true,
    }
  },
]
